import produce from "immer";
import { LoadState } from "../../constants/enums";
import { IStoreState } from "../initialStoreState";
import { IAgentToolsState } from "./AgentTools.types";
import {
  CLEAR_AGENT_TOOLS_STATE,
  FETCH_REGISTRY_LIST_FAILED,
  FETCH_REGISTRY_LIST_PROGRESS,
  FETCH_REGISTRY_LIST_SUCCESS,
  FETCH_REGISTRY_MAPPINGS_FAILED,
  FETCH_REGISTRY_MAPPINGS_PROGRESS,
  FETCH_REGISTRY_MAPPINGS_SUCCESS,
} from "./AgentToolsActions";
import { initialAgentToolsState } from "./defaultState";
import { AgentToolsActions } from ".";

export const agentToolsReducer = (
  state: IStoreState["agentTools"] = initialAgentToolsState,
  action: AgentToolsActions,
) => {
  switch (action.type) {
    // ─── Registry List ────────────────────────────────────────────────────────
    case FETCH_REGISTRY_LIST_PROGRESS: {
      const newState = produce(state, (draftState: IAgentToolsState) => {
        draftState.registry.loading = LoadState.InProgress;
      });
      return newState;
    }
    case FETCH_REGISTRY_LIST_SUCCESS: {
      const { data, totalRecords } = action.payload;
      const newState = produce(state, (draftState: IAgentToolsState) => {
        draftState.registry.loading = LoadState.Loaded;
        draftState.registry.data = data;
        draftState.registry.totalRecords = totalRecords;
      });
      return newState;
    }
    case FETCH_REGISTRY_LIST_FAILED: {
      const newState = produce(state, (draftState: IAgentToolsState) => {
        draftState.registry.loading = LoadState.Failed;
      });
      return newState;
    }

    // ─── Registry Mappings ────────────────────────────────────────────────────
    case FETCH_REGISTRY_MAPPINGS_PROGRESS: {
      const newState = produce(state, (draftState: IAgentToolsState) => {
        draftState.mappings.loading = LoadState.InProgress;
      });
      return newState;
    }
    case FETCH_REGISTRY_MAPPINGS_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState: IAgentToolsState) => {
        draftState.mappings.loading = LoadState.Loaded;
        draftState.mappings.data = data;
      });
      return newState;
    }
    case FETCH_REGISTRY_MAPPINGS_FAILED: {
      const newState = produce(state, (draftState: IAgentToolsState) => {
        draftState.mappings.loading = LoadState.Failed;
      });
      return newState;
    }

    // ─── Clear ────────────────────────────────────────────────────────────────
    case CLEAR_AGENT_TOOLS_STATE: {
      return initialAgentToolsState;
    }

    default:
      return state;
  }
};
